module.exports = __webpack_public_path__ + "fonts/Inter-100-latin10.5eb4a77.woff2";